import ReactBundle from "~app/ReactBundle";

import AppBundleContext from "~app/AppBundleContext";

export default new ReactBundle({
  contexts: [AppBundleContext],
  language: "en",
  resources: {
    strings: {
      languages: {
        en: () => require("./strings.json"),
      },
    },
    "header-title.svg": {
      require: require("./images/header-title.svg"),
    },
    "header.svg": {
      require: require("./images/header.svg"),
    },
    "banner.png": {
      require: require("./images/pptxgen/us-banner.png"),
    },
    "chart-basic.svg": {
      require: require("./images/chart/chart-younger.svg"),
    },
    "chart-detailed.svg": {
      require: require("./images/chart/chart-older.svg"),
    },
    "red-circle-basic.svg": {
      require: require("./images/simple/red-circle.svg"),
    },
    "green-circle-basic.svg": {
      require: require("./images/simple/green-circle.svg"),
    },
    "blue-circle-basic.svg": {
      require: require("./images/simple/blue-circle.svg"),
    },
    "purple-circle-basic.svg": {
      require: require("./images/simple/purple-circle.svg"),
    },
    "left-arrow-basic.svg": {
      require: require("./images/simple/left-arrow.svg"),
    },
    "right-arrow-basic.svg": {
      require: require("./images/simple/right-arrow.svg"),
    },
    "red-circle-detailed.svg": {
      require: require("./images/standard/red-circle.svg"),
    },
    "green-circle-detailed.svg": {
      require: require("./images/standard/green-circle.svg"),
    },
    "blue-circle-detailed.svg": {
      require: require("./images/standard/blue-circle.svg"),
    },
    "purple-circle-detailed.svg": {
      require: require("./images/standard/purple-circle.svg"),
    },
    "left-arrow-detailed.svg": {
      require: require("./images/standard/left-arrow.svg"),
    },
    "right-arrow-detailed.svg": {
      require: require("./images/standard/right-arrow.svg"),
    },
    "CallToAction.svg": {
      require: require("./images/CallToAction.svg"),
    },
    "simple-map.svg": {
      require: require("./images/simple-map.svg"),
    },
  },
});



// WEBPACK FOOTER //
// ./src/resources/en/bundle.js